import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { CursoDTO } from 'src/app/models/curso/cursoDTO';
import { FormacaoDTO } from 'src/app/models/curso/formacaoDTO';
import { FunctionsService } from 'src/app/services/common/functions.service';
import { FormacaoService } from 'src/app/services/formacao/formacao.service';
import { ModalidadeService } from 'src/app/services/modalidade/modalidade.service';

@Component({
  selector: 'app-popover-filtrar-cursos',
  templateUrl: './popover-filtrar-cursos.component.html',
  styleUrls: ['./popover-filtrar-cursos.component.scss'],
})
export class PopoverFiltrarCursosComponent implements OnInit {

  filtro: string = '';

  cursos: CursoDTO[];
  cursosFiltrados: CursoDTO[];
  cursosSelecionados: CursoDTO[];

  formacoes: FormacaoDTO[] = [];
  formacao: FormacaoDTO = new FormacaoDTO();


  constructor( private popoverController: PopoverController
             , private functionsService: FunctionsService
             , private formacaoService: FormacaoService ) { 

    this.formacaoService.findAll().subscribe({
      next:(resp)=>{
        this.formacoes= resp;
      },
      error:(error)=>{
        console.log(error);
      }
    });          
  }

  ngOnInit() {}

  ionViewWillEnter(){
   
    //inicialmente mostra todos os cursos
    this.cursosFiltrados =  this.cursos;
    this.functionsService.sortArray(this.cursosFiltrados);
    
  }

  filter(){

    this.cursosFiltrados = [];

    for(var i=0; i<this.cursos.length; i++){
      
      if( this.cursos[i].nome.toLocaleLowerCase().indexOf(this.filtro.toLocaleLowerCase())>-1 ||
          this.cursos[i].habilitacao?.nome.toLocaleLowerCase().indexOf(this.filtro.toLocaleLowerCase())>-1 ||
          this.cursos[i].modalidade?.nome.toLocaleLowerCase().indexOf(this.filtro.toLocaleLowerCase())>-1 ||
          this.cursos[i].formacao?.nome.toLocaleLowerCase().indexOf(this.filtro.toLocaleLowerCase())>-1){
        
        if(!this.formacao.id || this.formacao.id == this.cursos[i].formacao.id){
          this.cursosFiltrados.push(this.cursos[i]);
        }
        
      }

    }

  }


  



  checked(curso: CursoDTO): boolean{

    for(var i=0; i<this.cursosSelecionados?.length; i++){
      if(curso.id == this.cursosSelecionados[i].id){
        return true;
      }
    }

    return false;

  }


  addCurso(event, curso: CursoDTO){

    if(event.target.checked){
      
      let achou = false;
      for(var i=0; i<this.cursosSelecionados?.length; i++){
      
        if(this.cursosSelecionados[i].id == curso.id){
          achou = true;
          break;
        }
      }

      if(!achou){
        this.cursosSelecionados.push(curso);
      }
    
    }else{

      for(var i=0; i<this.cursosSelecionados?.length; i++){
      
        if(this.cursosSelecionados[i].id == curso.id){
          this.cursosSelecionados.splice(i,1);
          return;
        }
      }

    }
    
  }

  cancel(){
    this.popoverController.dismiss(null);
  }

  confirm(){
    this.popoverController.dismiss(this.cursosSelecionados);  
  }


  selectAll(){
    this.cursosSelecionados=this.functionsService.getDeepCopyArray(this.cursosFiltrados);
  }


  
}
